import { MDBAlert, MDBDatatable, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import {
  getMisc,
  getSpecificBIllingUser,
} from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";

function BillingUsers({ billingGInfo, isActive }) {
  const [users, setUsers] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [billingDetails, setBillingDetails] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);
  async function getSpecificUser() {
    try {
      const response = await getSpecificBIllingUser(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        billingGInfo.billing_group_id
      );
      const rawData = await response.json();
      console.log(
        "Specific billing group user :::::::::::::::" + JSON.stringify(rawData)
      );
      setUsers(rawData);
    } catch (e) {
      console.log(`Unable to load the sepcific billing group user:${e}`);
    }
  }
  useEffect(() => {
    if (isActive) {
      getSpecificUser();
    }
  }, [isActive]);

  useEffect(() => { 
  let processdrows = [];
  (users?.billing_users || []).map((user) => {
    processdrows.push({
      userInfo: user,
      name: user.username,
      extension: user?.extensions ?? "",
    //   remove: (
    //     <div className="d-flex align-items-center ms-2">
    //       <div
    //         className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
    //         onClick={(e) => deleteUsers(e, user?.agentid)}
    //       >
    //         <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
    //       </div>
    //     </div>
    //   ),
    });
  });
  setBillingDetails(processdrows);
  setFilteredRows(processdrows)
  setDataLoaded(true)
 },[users])
  

  const actionData = {
    columns: [
      { label: "Name", field: "name" },
      { label: "Extension", field: "extension" },
    //   { label: "Remove", field: "remove" },
    ],
    rows: billingDetails,
  };

//   function deleteUsers(evntData, agentid) {
//     console.log("Agentid ::::" + JSON.stringify(agentid));
//     evntData.preventDefault();
//     evntData.stopPropagation();
//     let seluser = users.billing_users.filter(
//       (udata) => udata.agentid == agentid
//     );
//     let agentId = seluser.map((val) => val.agentid);
//   }

//   useEffect(() => {
//     async function getBillingInfoMisc(e) {
//       const response = await getMisc(
//         JSON.parse(sessionStorage.getItem("admin_session")).siteid,
//         {
//           misc: ["billing_settings_info"],
//           billing_group_id: billingGInfo.billing_group_id,
//         }
//       );
//       console.log(response);
//       if (!response.json) {
//         const message = `An error has occured: ${response.statusText}`;
//         return;
//       }
//       const tdata = await response.json();
//       if (!tdata) {
//         window.alert(`info with id  not found`);
//         navigate("/");
//       }
//       console.log(
//         "billing info misc details ::::::::: " + JSON.stringify(tdata)
//       );
//     }

//     if (billingGInfo.billing_group_id) {
//       getBillingInfoMisc();
//     }
//   }, [billingGInfo]);


const handleManualSearch = (searchValue) => {
  setsearchValue(searchValue); 
  const filteredUsers = customSearch(billingDetails, searchValue, UIConstant.BILLING_USERS);

  setFilteredRows(filteredUsers);
};


  return (
    <>
      <div>
        <div className="actionbar"></div>
        <div className='mb-2 mt-2 position-relative w-auto'>
          <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
          <MDBIcon fas icon="search" className='MDBDatatable-Search' />
        </div>
        <div className="locationUsersDatatble">
          <MDBDatatable
             key={searchValue}
            entries={50}
            data={{
              ...actionData,
              rows: filteredRows,
            }}
            className="actioncolumn"
            sortField="Billing Groups"
          />
        </div>
        {/* {successMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        )} */}
      </div>
    </>
  );
}

export default BillingUsers;
